import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FAQ.css';

const FAQ = () => {
  const navigate = useNavigate();

  // ✅ Added scrollTop helper
  const scrollTop = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div className="faq-container">
      {/* Header Section */}
      <div className="faq-header">
        <h1 className="faq-title">Frequently Asked Questions</h1>
        <div className="breadcrumb">
          <button className="breadcrumb-home" onClick={() => scrollTop('/')}>
            Home
          </button>
          <span className="breadcrumb-separator">&gt;</span>
          <span className="breadcrumb-current">FAQ</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="faq-content">
        <div className="faq-text">
          <h2 className="section-title">General Questions</h2>
          <div className="faq-item">
            <h3 className="faq-question">What is HotelPlacement.ae?</h3>
            <p className="faq-answer">
              HotelPlacement.ae is a comprehensive hospitality job board and recruitment platform dedicated to connecting talented professionals with top-tier hospitality establishments in Dubai and the UAE. We specialize in hotel jobs, restaurant positions, and hospitality careers.
            </p>
          </div>
          <div className="faq-item">
            <h3 className="faq-question">How do I create an account?</h3>
            <p className="faq-answer">
              You can create an account by clicking on the "Register" button and selecting your user type (Candidate, College, Admin, Customer, or Recruiter). Follow the registration process and complete your profile to get started.
            </p>
          </div>
          <div className="faq-item">
            <h3 className="faq-question">What types of jobs are available?</h3>
            <p className="faq-answer">
              We offer positions across all hospitality departments including Front Office, Food & Beverage Production, Food & Beverage Service, Housekeeping, Spa & Wellness, Laundry, Operations, Human Resources, and Engineering departments.
            </p>
          </div>

          <h2 className="section-title">For Job Seekers</h2>
          <div className="faq-item">
            <h3 className="faq-question">How do I apply for jobs?</h3>
            <p className="faq-answer">
              Once you've created your candidate account and completed your profile, you can browse available positions and apply directly through our platform. Make sure your profile is complete and up-to-date for better chances of selection.
            </p>
          </div>
          <div className="faq-item">
            <h3 className="faq-question">Can students apply for internships?</h3>
            <p className="faq-answer">
              Yes! HotelPlacement.ae provides internship opportunities for hotel school students. We believe in nurturing young talent and providing practical experience in the hospitality industry.
            </p>
          </div>
          <div className="faq-item">
            <h3 className="faq-question">Is there a fee for job seekers?</h3>
            <p className="faq-answer">
              No, our platform is completely free for job seekers. You can create an account, browse jobs, and apply without any charges.
            </p>
          </div>

          <h2 className="section-title">For Employers</h2>
          <div className="faq-item">
            <h3 className="faq-question">How do I post job openings?</h3>
            <p className="faq-answer">
              Employers can register as recruiters and post job openings through our platform. You'll have access to our applicant tracking system and can manage applications efficiently.
            </p>
          </div>
          <div className="faq-item">
            <h3 className="faq-question">What services do you offer to employers?</h3>
            <p className="faq-answer">
              We provide a complete recruitment solution including job posting, applicant tracking, assessment tools, talent community access, and onboarding support for your new hires.
            </p>
          </div>

          <h2 className="section-title">Technical Support</h2>
          <div className="faq-item">
            <h3 className="faq-question">I'm having trouble logging in. What should I do?</h3>
            <p className="faq-answer">
              If you're experiencing login issues, try resetting your password using the "Forgot Password" option. If the problem persists, contact our support team at info@hotelplacement.ae.
            </p>
          </div>
          <div className="faq-item">
            <h3 className="faq-question">How can I contact support?</h3>
            <p className="faq-answer">
              You can reach our support team via email at info@hotelplacement.ae or call us at 971-42503121. We're located at Aspin Towers, Sheikh Zayed Road, Dubai, UAE.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="faq-footer">
        <div className="footer-content">
          <div className="footer-column">
            <h3>Contact Us</h3>
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <span>Aspin Towers, Sheikh Zayed Road, Dubai, UAE</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📱</span>
              <span>971-42503121</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">✉️</span>
              <span>info@hotelplacement.ae</span>
            </div>
          </div>
          <div className="footer-column">
            <h3>Company & Policy</h3>
            <div className="policy-links">
              <button className="policy-link" onClick={() => scrollTop('/AboutUs')}>About Us</button>
              <button className="policy-link" onClick={() => scrollTop('/')}>Home</button>
              <button className="policy-link active">FAQs</button>
              <button className="policy-link" onClick={() => scrollTop('/privacy-policy')}>Privacy Policy</button>
              <button className="policy-link" onClick={() => scrollTop('/terms-conditions')}>Terms & Condition</button>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 HotelPlacement.ae. All rights reserved.</p>
            <div className="footer-social">
              <span>Follow us:</span>
              {/* ✅ FIXED: Added valid hrefs and security attributes */}
              <a 
                href="https://www.linkedin.com" 
                className="social-link"
                target="_blank" 
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <a 
                href="https://twitter.com" 
                className="social-link"
                target="_blank" 
                rel="noopener noreferrer"
              >
                Twitter
              </a>
              <a 
                href="https://www.facebook.com" 
                className="social-link"
                target="_blank" 
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FAQ;